export const aggregatePeriodFigures = (periods, periodIndexes) => {
  const selected = (periodIndexes || [])
    .map(index => periods?.[index])
    .filter(Boolean);
  if (!selected.length) return null;

  const profitAndLoss = selected.reduce(
    (sum, figure) => sum + (figure.profitAndLoss ?? 0),
    0
  );
  const budget = selected.reduce(
    (sum, figure) => sum + (figure.budget ?? 0),
    0
  );
  const variance = profitAndLoss - budget;

  let variancePercent = null;
  if (budget !== 0) {
    variancePercent = (variance / budget) * 100;
  } else if (profitAndLoss !== 0) {
    variancePercent = 100;
  }

  return { profitAndLoss, budget, variance, variancePercent };
};
